import _ from "lodash";

const SPECIAL_CASE_FORM_ERRORS = ["dhcp.custom"];

const MESSAGES = {
    netsuite: {
        cancelOrder: "There was an error cancelling this order. Please contact customer support",
        default: "There was an error from NetSuite. Please try again later."
    }
};

function getFormErrors(data) {
    let errors = {};

    //Cloud errors
    if (data && data.meta && data.meta.source) {
        errors[""] = MESSAGES[data.meta.source][data.meta.message] || MESSAGES[data.meta.source].default;
    } else if (data && data.meta && data.meta.message) {
        switch (data.meta.message) {
            case "form errors encountered":
                _.forOwn(data.data, (val, key)=> {
                    if (SPECIAL_CASE_FORM_ERRORS.indexOf(key) >= 0) {
                        errors[""] = val;
                    } else {
                        //This is a hack so that form erros with "." try to map to inputs by the deepest property name
                        //E.G. lease.static.ip will check for an input named "ip"
                        let nameArr = key.split(".");

                        errors[nameArr[nameArr.length - 1]] = val ? val[0] : null;
                    }
                });
                break;
            case "Password did not match":
                errors.password = "Password did not match";
                break;
            case "Login failed":
                errors[""] = "Incorrect username or password";
                break;
            default:
                errors[""] = `Unhandled server error message: "${data.meta.message}"`;
        }
        //Stripe errors
    } else if (data.error && data.error.code) {
        if (data.error.param && data.error.message) {
            errors[data.error.param] = data.error.param === "address_zip" ? "Incorrect zip" : data.error.message;
        } else {
            errors[""] = data.error.message || "Unhandled Stripe error";
        }
    } else {
        errors[""] = "Unexpected server error response";
    }

    console.log("form errors:", errors);

    return errors;
}

export default getFormErrors;



/** WEBPACK FOOTER **
 ** ./app/utils/functions/getFormErrors.js
 **/